import { render } from "./hotSearch.vue?vue&type=template&id=2e19cda4"
import script from "./hotSearch.vue?vue&type=script&lang=js"
export * from "./hotSearch.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__